import { SidebarDTO } from '@models/sidebar.model';

/**
 * Configuración del menú lateral.
 *
 * Módulos "solo-backend" (URLs sin página en el frontend, ej. utilidades del dominio vet:
 * número a letras y ubigeo). Estos módulos existen en el catálogo con
 * permisos por rol (los usa el backend para orquestar permisos) y se gestionan desde la
 * pantalla de Permisos/Módulos, pero NO deben aparecer como items navegables en el sidebar.
 *
 * El filtro aplica SOLO en el componente del menú lateral (`app-sidebar-menu`); el resto
 * (top-nav, búsqueda, breadcrumb, gestión de Módulos/Permisos) NO lo aplica.
 */
export const HIDDEN_SIDEBAR_MODULE_URLS: string[] = [
  '/vet/utils',
  '/vet/ubigeo',
  // Módulo técnico del ÁREA de configuración: existe en el catálogo para el gating de permisos
  // (horarios, tipos de cita, documentos…), pero la pantalla visible es "Ajustes de impresión".
  '/vet/configuracion',
  // Capacidades técnicas sin pantalla: el check-in y la atención clínica (historia de la visita,
  // recetas, vacunas, iniciar/cerrar). El flujo vive dentro de la Agenda.
  '/vet/check-in',
  '/vet/atencion',
];

/**
 * Devuelve una copia del árbol del sidebar sin los módulos ocultos (y sin las categorías/grupos
 * que quedarían vacíos). No muta el dato original (la caché de PermissionService es compartida).
 */
export function filterSidebarForMenu(
  data: SidebarDTO,
  hidden: string[] = HIDDEN_SIDEBAR_MODULE_URLS,
): SidebarDTO {
  const hiddenSet = new Set(hidden);
  const groups = data.groups
    .map((group) => {
      const categories = group.categories
        .map((category) => ({
          ...category,
          modules: category.modules.filter((module) => !hiddenSet.has(module.url)),
        }))
        .filter((category) => category.modules.length > 0);
      return { ...group, categories };
    })
    .filter((group) => group.categories.length > 0);
  return { groups };
}
